export default __webpack_public_path__ + "static/media/Sponsor_table_20220808_en.4320c9bc.svg";